import { Switch, useRouteMatch } from 'react-router';
import { AdministrationRoute, PrivateRoute } from 'common/AuthRoute';
import React, { memo } from 'react';
import { BusinessPartnerDoctorsPage } from 'pages/BusinessPartnerManagement/BusinessPartnerDoctorsManagement/BusinessPartnerDoctorsPage';
import { BusinessPartnerDoctorPage } from 'pages/BusinessPartnerManagement/BusinessPartnerDoctorsManagement/BusinessPartnerDoctorPage';
import { BusinessPartnerRegisterDoctorPage } from 'pages/BusinessPartnerManagement/BusinessPartnerDoctorsManagement/BusinessPartnerRegisterDoctorPage';
import { BusinessPartnerDoctorsManagementRoutes } from 'pages/BusinessPartnerManagement/BusinessPartnerDoctorsManagement/businessPartnerDoctorsManagementRoutes';

export const BusinessPartnerDoctorsManagement = memo(() => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <PrivateRoute exact path={path} component={BusinessPartnerDoctorsPage} />
      <AdministrationRoute
        exact
        path={`${path}/${BusinessPartnerDoctorsManagementRoutes.Register}`}
        component={BusinessPartnerRegisterDoctorPage}
      />
      <PrivateRoute
        exact
        path={`${path}/${BusinessPartnerDoctorsManagementRoutes.Details}`}
        component={BusinessPartnerDoctorPage}
      />
    </Switch>
  );
});
